import { Button, Grid } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CaretRight from "../../../../assets/images/icons/CaretRight";
import { CoachList, Title } from "../../../../components";
import { useLayout } from "../../../../context/LayoutContext";
import { CoachResponse } from "../../../../hooks/Coach/data";
import styles from "./styleModule";

const CoachHot: React.FC<{ coaches: CoachResponse[] }> = ({ coaches }) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { getContentPadding } = useLayout();
  const navigate = useNavigate();

  const getWidth = () => {
    if (screens.xxl) return "calc(100% - 480px)";
    if (screens.md) return "calc(100% - 80px)";
    return "calc(100% - 32px)";
  };

  return (
    <div
      className={`${styles.contentWrapper} ${screens.sm ? "" : styles.mobile}`}
      style={{ width: getWidth() }}
    >
      <div className={styles.border} />
      <div
        className={`${styles.titleWrapper} ${screens.sm ? "" : styles.mobile}`}
      >
        <Title
          title={t("home.coach.title")}
          subtitle={t("home.coach.subtitle")}
        />
        {screens.sm ? (
          <Button
            type="link"
            iconPosition={"end"}
            onClick={() => navigate("/trainers")}
            style={{ padding: 0 }}
            icon={
              <CaretRight style={{ fontSize: 24, color: "var(--primary)" }} />
            }
          >
            {t("home.coach.more")}
          </Button>
        ) : null}
      </div>

      <div
        className={`${styles.coachContainer} ${
          screens.sm ? "" : styles.mobile
        }`}
      >
        <CoachList coachList={coaches} />
      </div>
    </div>
  );
};

export default CoachHot;
